<template>
  <div class="px-4 sm:px-0">
    <PageTitle
      :title="$gettext('Locations')"
      :description="$gettext('Voici un résumé de l\'ensemble des locations.')"
    />
    <div class="mt-8 flow-root">
      <div v-if="rentalListingAgreementStore.totalCount == 0 && !rentalListingAgreementStore.searchQuery" class="text-center p-20">
        <p class="mt-1 text-sm text-gray-500">{{ $gettext("Désolé, mais nous ne trouvons pas de location pour l'instant...") }}</p>
        <div class="mt-6">
          <router-link :to="{ name: 'new-rental-listing-agreement' }"
            class="inline-flex items-center rounded-md bg-indigo-600 m-5 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            <PlusIcon class="-ml-0.5 mr-1.5 size-5 rounded-md border border-white-900" aria-hidden="true" />
            {{ $gettext("Nouvelle location") }}
          </router-link>
        </div>
      </div>
      <div v-else>
        <div class="flex justify-between items-center mb-4">
          <div class="relative w-96">
            <MagnifyingGlassIcon class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 size-5" />
            <input v-model="rentalListingAgreementStore.searchQuery" type="text" :placeholder="$gettext('Chercher un mission de location...')"
              class="w-full pl-10 p-2 border rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
          </div>
          <div>
            <router-link :to="{ name: 'new-rental-listing-agreement' }"
              class="mr-5 inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              <PlusIcon class="-ml-0.5 mr-1.5 size-5 rounded-md border border-white-900" aria-hidden="true" />
              {{ $gettext("Nouvelle mission de location") }}
            </router-link>
          </div>
        </div>
        <div class="mt-8">
          <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <table v-if="rentalListingAgreementStore.all.length > 0" class="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">{{ $gettext("Bailleur(s)") }}</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{ $gettext("Propriété(s)") }}</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{ $gettext("Commission") }}</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{ $gettext("Date de fin") }}</th>
                    <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-0"></th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr
                    v-for="rentalListingAgreement in rentalListingAgreementStore.paginated"
                    :key="rentalListingAgreement.id"
                    class="even:bg-gray-50 hover:bg-indigo-50 transition-colors duration-300 cursor-pointer"
                    @click="$router.push({ name: 'rental-listing-agreement', params: { id: rentalListingAgreement.id } })"
                  >
                    <RentalListingAgreementItemView :rentalListingAgreement="rentalListingAgreement" />
                  </tr>
                </tbody>
              </table>
              <div v-else class="text-center py-20">
                <h3 class="mt-2 text-sm font-semibold text-gray-900">{{ $gettext("Pas de résultats trouvés") }}</h3>
              </div>
            </div>
          </div>
        </div>
        <PaginationNavigation :store="rentalListingAgreementStore" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { PlusIcon } from "@heroicons/vue/20/solid";
import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import { useRentalListingAgreementStore } from "@/stores/rentalListingAgreement.js";
import PaginationNavigation from "@/components/layout/PaginationNavigation.vue";
import PageTitle from "@/components/layout/PageTitle.vue";
import RentalListingAgreementItemView from "@/views/rental-listing-agreements/RentalListingAgreementItemView.vue";
const rentalListingAgreementStore = useRentalListingAgreementStore();

const overviewIncludes = [
  "rentalListingAgreementLandlords",
  "rentalListingAgreementProperties",
  "commissionType",
  "properties",
  "physicalPersonLandlords",
  "companyLandlords"
];

onMounted(async () => {
  await rentalListingAgreementStore.fetchAll(null, overviewIncludes);
  await rentalListingAgreementStore.watchResourceChanges(() => {
    rentalListingAgreementStore.fetchAll(null, overviewIncludes);
  });
});
</script>
